var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.607 10.999l7.366-7.751 7.476 7.579L18 9.177 8.916 0 0 9.404l1.607 1.595z",
    fill: "#E0621E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxOCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xLjYwNzE0IDEwLjk5ODdMOC45NzI5NyAzLjI0Nzc1TDE2LjQ0OTQgMTAuODI2OEwxOCA5LjE3Njc3TDguOTE2NDMgLTcuOTQxMTFlLTA3TDMuNzc4NjJlLTA3IDkuNDAzNjFMMS42MDcxNCAxMC45OTg3WiIgZmlsbD0iI0UwNjIxRSIvPgo8L3N2Zz4K";
export { SvgOrangeArrowIcon as ReactComponent };